import React from 'react';
import {
  BRAND_VALUES,
  CONTACT_INFO,
  EXPERIENCE_STEPS,
  PIZZERIA_NAME,
} from '../constants';
import SectionHeading from './SectionHeading';

const UeberUns = ({ onBackHome }) => {
  return (
    <div className="section-surface section-surface-tinted">
      <div className="mx-auto max-w-7xl px-6 pb-20 pt-4 lg:px-10 lg:pb-24 lg:pt-6">
        <button
          type="button"
          onClick={onBackHome}
          className="mb-6 inline-flex items-center justify-center rounded-full border border-stone-300 bg-white px-5 py-2.5 text-sm font-semibold text-stone-900 shadow-sm transition hover:border-orange-300 hover:bg-orange-50 hover:text-orange-700"
        >
          ← Zurück
        </button>

        <SectionHeading
          title={`${PIZZERIA_NAME} wirkt jetzt wie ein echter Markenauftritt.`}
          description="Der Bereich zeigt nicht nur irgendeinen Fließtext, sondern eine saubere Positionierung: Arbeitsweise, Werte und der Ablauf hinter dem Produkt."
        />

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {BRAND_VALUES.map((value) => (
            <article
              key={value.title}
              className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm"
            >
              <h3 className="text-2xl font-semibold tracking-tight text-stone-950">
                {value.title}
              </h3>
              <p className="mt-4 text-base leading-7 text-stone-700">
                {value.description}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="rounded-[2rem] border border-stone-200 bg-[linear-gradient(180deg,_rgba(255,237,213,0.85),_rgba(255,255,255,0.96)_68%)] p-8 shadow-sm">
            <p className="text-sm uppercase tracking-[0.28em] text-orange-700">
              So entsteht das Produkt
            </p>
            <div className="mt-8 space-y-6">
              {EXPERIENCE_STEPS.map((step, index) => (
                <div key={step.title} className="grid gap-3 md:grid-cols-[auto_1fr]">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-orange-200 bg-white text-sm font-semibold text-orange-700 shadow-sm">
                    0{index + 1}
                  </span>
                  <div>
                    <h3 className="text-xl font-semibold text-stone-950">{step.title}</h3>
                    <p className="mt-2 text-sm leading-7 text-stone-700">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <aside className="rounded-[2rem] border border-stone-200 bg-white p-7 shadow-sm">
            <p className="text-sm uppercase tracking-[0.28em] text-stone-600">
              Standort & Erreichbarkeit
            </p>

            <div className="mt-6 space-y-2 text-base text-stone-700">
              <p className="font-semibold text-stone-950">{CONTACT_INFO.addressLines[0]}</p>
              <p>{CONTACT_INFO.addressLines[1]}</p>
              <a
                href={CONTACT_INFO.emailHref}
                className="inline-block text-sm font-semibold text-orange-700"
              >
                {CONTACT_INFO.email}
              </a>
            </div>

            <a
              href={CONTACT_INFO.phoneHref}
              className="mt-7 inline-flex w-full items-center justify-center rounded-full bg-emerald-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-emerald-700"
            >
              {CONTACT_INFO.phone}
            </a>

            <div className="mt-7 rounded-[1.5rem] border border-orange-100 bg-orange-50 p-5">
              <p className="text-sm font-semibold uppercase tracking-[0.24em] text-orange-700">
                Öffnungszeiten
              </p>
              <div className="mt-4 space-y-3">
                {CONTACT_INFO.openingHours.map((entry) => (
                  <div
                    key={entry.days}
                    className="flex items-center justify-between gap-4 border-b border-orange-100 pb-2 last:border-b-0 last:pb-0"
                  >
                    <span className="text-sm text-stone-700">{entry.days}</span>
                    <span className="text-sm font-semibold text-stone-950">{entry.hours}</span>
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default UeberUns;
